// 微信开放平台「扫码登录」在 bindings 中的渠道 key
// （公众号「通知」是另一渠道 WeChatOfficialAccount，勿混用）
export const WECHAT_LOGIN_BIND_KEY = 'WeChatWebsiteApp'

// 从 bindings（[{ 渠道key: valueObj }]）中取扫码登录绑定值；未绑返回 null。
// value 形如 { avatar, nickname, [唯一标识?] }；空对象也代表已绑定。
export function getWechatLoginBinding(bindings) {
  const list = Array.isArray(bindings) ? bindings : []
  const hit = list.find(
    (b) => b && Object.prototype.hasOwnProperty.call(b, WECHAT_LOGIN_BIND_KEY),
  )
  return hit ? hit[WECHAT_LOGIN_BIND_KEY] : null
}

// 是否已绑定微信扫码登录（有 key 即视为已绑，含空对象）
export function hasWechatLoginBinding(bindings) {
  return getWechatLoginBinding(bindings) != null
}
